import React, { lazy } from 'react';

// 1. HOME: Keep this Static (No changes needed here)
import Home from "./components/Home";

// 2. NAMED EXPORTS: Fix for Counter & FetchData
// We use ".then()" to map the named export to 'default' so lazy works.
const Counter = lazy(() => import("./components/Counter").then(module => ({ default: module.Counter })));
const FetchData = lazy(() => import("./components/FetchData").then(module => ({ default: module.FetchData })));

// 3. DEFAULT EXPORTS: These are fine as-is
//const Home = lazy(() => import("./components/Home"));
const Search = lazy(() => import("./components/Search"));
const PropertyDetails = lazy(() => import("./components/PropertyDetails"));
const Profile = lazy(() => import("./components/Profile"));
const Construction = lazy(() => import("./components/Construction"));
const Neighborhoods = lazy(() => import("./components/Neighborhoods"));
const NeighborhoodList = lazy(() => import("./components/NeighborhoodList"));
const NeighborhoodDetails = lazy(() => import("./components/NeighborhoodDetails"));
const Builders = lazy(() => import("./components/Builders"));
const SearchRental = lazy(() => import('./components/SearchRental'));
const Community = lazy(() => import('./components/Community'));
const Favorites = lazy(() => import("./components/Favorites"));

const AppRoutes = [
  {
    index: true,
    element: <Home />
  },
  {
    path: '/search',
    element: <Search />
  },
  {
    path: "/search/:city",
    element: <Search />
  },
  {
    path: '/counter',
    element: <Counter />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
  },
  {
    path: "/details/:MlsNumber/:MasterId",
    element: <PropertyDetails />,
  },
  {
    path: "/profile",
    element: <Profile />
  },
  {
    path: "/favorites",
    element: <Favorites />
  },
  {
    path: "/rentals",
    element: <SearchRental />
  },
  {
    path: "/rentals/:city",
    element: <SearchRental />
  },
  // Inline components don't need lazy loading, but that's fine
  {
    path: "/contact",
    element: <div style={{padding:100}}><h2>Contact Us</h2><p>Contact us will appear here.</p></div>
  },
  {
    path: "/lakehomes",
    element: <div style={{padding:100}}><h2>lake homes</h2><p>Your lake view properties will appear here.</p></div>
  },
  {
    path: "/construction/:id",
    element: <Construction />
  },
  {
    path: "/neighborhoods",
    element: <Neighborhoods />
  },
  {
    path: "/bUilders",
    element: <Builders />
  },
  {
    path: "/bUilders/:city",
    element: <Builders />
  },
  {
    path: "/neighborhoods/:city",
    element: <NeighborhoodList />
  },
  {
    path: "/neighborhoodlist",
    element: <NeighborhoodList />
  },
  {
    path: "/neighborhoodlist/:city",
    element: <NeighborhoodList />
  },
  {
    path: "/neighborhooddetails/:id",
    element: <NeighborhoodDetails />
  },
  {
    path: "/neighborhooddetails/:id/:city",
    element: <NeighborhoodDetails />
  },
  {
    path: "/planetre/Community",
    element: <Community />
  }
];

export default AppRoutes;